<nz-table #basicTable [nzBordered]="false" [nzData]="listOfTasks" [nzSize]="'small'" [nzShowPagination]="'false'" class="shadow">
  <thead>
    <tr>
      <th nzWidth="10%">ID</th>
      <th nzWidth="30%">Task</th>
      <th nzWidth="20%">Project</th>
      <th nzWidth="15%">Priority</th>
      <th nzWidth="15%">Due Date</th>
      <th nzWidth="15%">Status</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let task of listOfTasks; let i = index">
      <td> <nz-tag> {{ formatIdToFourDigits(task.id , 'TS') }} </nz-tag></td>
      <td style="font-weight: bold;">
        <a href="javascript:void(0)" (click)="openTaskDetailModal(task)">
          {{ task.name }}  
        </a> </td>
      <td>{{ task.project_name }}</td>
      <td>
        <nz-tag [nzColor]="getPriorityColor(getTaskPriorityName(task.priority))">{{ getTaskPriorityName(task.priority) }}</nz-tag>
      </td>
      <td>{{ task.due_date | date:'yyyy-MM-dd' }}</td>
      <td>
        <nz-tag [nzColor]="getStatusColor(task.task_status)">{{ task.task_status_name }}</nz-tag>
      </td>
    </tr>
  </tbody>
</nz-table>